import { forwardRef } from "react";
import { SlidersHorizontal, Award, Languages, FileOutput } from "lucide-react";

const features = [
  {
    icon: SlidersHorizontal,
    num: "01",
    title: "Inventário 100% Customizável",
    description:
      "Não se prenda a modelos rígidos. Com mais de 25 tipos de campos disponíveis, pode criar fichas de inventário à medida de cada objeto, documento ou obra de arte.",
  },
  {
    icon: Award,
    num: "02",
    title: "Rigor Científico Internacional",
    description:
      "Trabalhe com confiança. O nosso sistema baseia-se no modelo CIDOC-CRM, garantindo a interoperabilidade e o cumprimento das normas internacionais de documentação.",
  },
  {
    icon: Languages,
    num: "03",
    title: "Gestão Multilingue Avançada",
    description:
      "Prepare a sua coleção para o mundo. Traduza conteúdos e interface em tempo real, com suporte total para idiomas da direita para a esquerda (RTL).",
  },
  {
    icon: FileOutput,
    num: "04",
    title: "Interoperabilidade Total (API & Exportação)",
    description:
      "Os seus dados são seus. Exporte em PDF, XML, Excel, Dublin Core ou RDF com um clique, ou ligue-se a outras aplicações através da nossa API REST.",
  },
];

const FeaturesSection = forwardRef<HTMLElement>((_, ref) => {
  return (
    <section ref={ref} id="funcionalidades" className="py-24 bg-muted/50 border-y border-border">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-muted-foreground font-semibold text-xs uppercase tracking-[0.2em] mb-3">Funcionalidades</p>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground text-balance">
            Criado para se adaptar ao seu património, não o contrário.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {features.map((f) => (
            <div
              key={f.num}
              className="group p-8 bg-background border border-border hover:border-foreground/20 transition-all duration-300"
            >
              <div className="flex items-start gap-5">
                <div className="flex-shrink-0">
                  <span className="text-3xl font-serif font-bold text-border group-hover:text-foreground/20 transition-colors">
                    {f.num}
                  </span>
                </div>
                <div>
                  <div className="flex items-center gap-3 mb-3">
                    <f.icon className="w-5 h-5 text-foreground" strokeWidth={1.5} />
                    <h3 className="text-lg font-bold text-foreground font-serif">{f.title}</h3>
                  </div>
                  <p className="text-muted-foreground leading-relaxed">{f.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

FeaturesSection.displayName = "FeaturesSection";

export default FeaturesSection;
